export default __webpack_public_path__ + "static/media/iphone.96981f4f.png";